// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

import {
  Input,
  RenderInputFields,
  SubmitButton,
  PhoneNumber,
  ReactSelectInput,
  SelectInput,
  PhoneNumberInput,
} from "../Form/Form";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
    // clearErrors
  } = useForm();

  const imgArray = ["image/png", "image/jpeg", "image/jpg"];

  const history = useHistory();
  const [image, setImage] = useState("");
  const [image1, setImage1] = useState("");
  const [brands, setBrands] = useState([]);
  const { response, request } = useRequest();
  const { request: requestBrands, response: responseBrands } = useRequest();
  const [isOtherBrand, setIsOtherBrand] = useState(false);

  useEffect(() => {
    if (response) {
      toast.success("Offer has been added successfully.");
      history.push("/offers");
    }
  }, [response]);

  useEffect(() => {
    requestBrands("GET", "brand");
  }, []);
  useEffect(() => {
    if (responseBrands) {
      setBrands(responseBrands?.data);
    }
  }, [responseBrands]);

  const displayImageHandler = (e) => {
    setImage(URL.createObjectURL(e.target.files[0]));
  };
  const handleRemoveMedia = () => {
    setValue("profilePic", "");
    setImage("");
  };

  const handleRemoveMedia1 = () => {
    setValue("brandPic", "");
    setImage1("");
  };

  const displayImageHandler1 = (e) => {
    setImage1(URL.createObjectURL(e.target.files[0]));
  };

  const onSubmit = (data) => {
    let {
      type,
      brands,
      code,
      description,
      profilePic,
      otherBrandName,
      brandPic,
      offerStartDate,
      offerEndDate,
      discountAmount,
    } = data;

    // if (email) {
    //   email = email.toLowerCase();
    // }

    const formData = new FormData();
    formData.append("type", type);
    offerStartDate && formData.append("offerStartDate", offerStartDate);
    offerEndDate && formData.append("offerEndDate", offerEndDate);

    formData.append("brand", brands);
    formData.append("code", code);
    formData.append("description", description);
    formData.append("discountAmount", discountAmount);

    if (isOtherBrand) {
      formData.append("brandName", otherBrandName);
      if (brandPic && brandPic[0]) {
        const profilePicType = brandPic[0].type;
        if (!imgArray.includes(profilePicType)) {
          toast.error("Please select image only in Brand Image");
          return;
        } else {
          formData.append("brand-images", brandPic[0]);
        }
      }
    }

    if (profilePic && profilePic[0]) {
      const profilePicType = profilePic[0].type;
      if (!imgArray.includes(profilePicType)) {
        toast.error("Please select image only in Offer Image");
        return;
      } else {
        formData.append("offer-image", profilePic[0]);
      }
    }

    // console.log(formData,'formDataformData')
    // return
    request("POST", "offer/add", formData);
  };

  console.log(isOtherBrand, "isOtherBrand");

  const InputFields = [
    [
      {
        Component: SelectInput,
        label: "Type",
        name: "type",
        registerFields: {
          required: true,
        },
        children: (
          <>
            <option value="">Select</option>
            <option value="flat">Flat</option>
            <option value="percentage">Percentage</option>
          </>
        ),
      },

      {
        Component: Input,
        label: "Code",
        type: "text",
        name: "code",
        registerFields: {
          required: true,
          //   pattern: /^[A-Za-z]+$/,
        },
        // registerFieldsFeedback: {
        //   pattern: "code can only contain letters.",
        // },
      },
      {
        Component: Input,
        label: "Discount Amount",
        type: "number",
        name: "discountAmount",
        registerFields: {
          required: true,
          //   pattern: /^[A-Za-z]+$/,
        },
        registerFieldsFeedback: {
          pattern: "Last Name can only contain letters.",
        },
      },
      {
        Component: Input,
        label: "Description",
        type: "text",
        name: "description",
        registerFields: {
          required: false,
          //   pattern: /^[A-Za-z]+$/,
        },
        registerFieldsFeedback: {
          pattern: "Last Name can only contain letters.",
        },
      },

      {
        Component: SelectInput,
        label: "Brand Name",
        name: "brands",
        registerFields: {
          required: true,
        },
        onChange: (value) => {
          setIsOtherBrand(value == "other");
        },
        children: (
          <>
            <option value="">Select</option>
            <option value="other">Other</option>
            {brands.map((item) => {
              return (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              );
            })}
          </>
        ),
      },

      {
        Component: Input,
        label: "Other Brand Name",
        type: "text",
        name: "otherBrandName",
        registerFields: {
          required: true,
        },
        isShow: isOtherBrand,
        control,
      },

      {
        Component: Input,
        label: "Brand Image",
        type: "file",
        name: "brandPic",
        registerFields: {
          required: false,
          // setValueAs: (a) => a.trim(),
        },
        registerFieldsFeedback: {
          // pattern: "The zip code field must be a valid zip code.",
        },
        isShow: isOtherBrand,
        handleMedia: displayImageHandler1,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: image1 && (
          <>
            <img
              src={image1}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveMedia1} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },

      {
        Component: Input,
        label: "Offer Image",
        type: "file",
        name: "profilePic",
        note: " 800px X 300px ",
        registerFields: {
          required: false,
          setValueAs: (v) => v.trim(),
        },
        registerFieldsFeedback: {
          // pattern: "The zip code field must be a valid zip code.",
        },
        handleMedia: displayImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: image && (
          <>
            <img
              src={image}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />

        

            <Link to="#" onClick={handleRemoveMedia} className="mx-3">
              Remove
            </Link>

            
          </>
        ),
      },
      {
        Component: Input,
        label: "Offer Start Date",
        type: "date",
        name: "offerStartDate",
        registerFields: {
          required: false,
          setValueAs: (v) => v.trim(),
        },
        inputData: {
          min: moment().format("YYYY-MM-DD"),
        },
        registerFieldsFeedback: {
          // pattern: "The zip code field must be a valid zip code.",
        },
      },
      {
        Component: Input,
        label: "Offer End Date",
        type: "date",
        name: "offerEndDate",
        registerFields: {
          required: false,
          setValueAs: (v) => v.trim(),
        },
        inputData: {
          min: moment().format("YYYY-MM-DD"),
        },
        registerFieldsFeedback: {
          // pattern: "The zip code field must be a valid zip code.",
        },
      },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Offer"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/offers", name: "Back To Offer" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Add New Offer</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <RenderInputFields
                      InputFields={InputFields}
                      errors={errors}
                      register={register}
                    />

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
